// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { fontConfig } from "@conklin/XDL/PreStyle/typography";
import { color, ellipsis, mergeWithCss } from "@conklin/XDL/Utilities";
import wrapInContainerStyles from "@insite/client-framework/Common/wrapInContainerStyles";
import { ProductDescriptionStyles } from "@insite/content-library/Components/ProductDescription";
import { StyledTypography } from "@insite/mobius/Link";
import { TypographyProps } from "@insite/mobius/Typography";
import { StyledProp } from "@insite/mobius/utilities/InjectableCss";
import { css } from "styled-components";

interface ProductDescriptionVariantStyles {
    small?: ProductDescriptionStyles;
    medium?: ProductDescriptionStyles;
}

const sharedStyles: StyledProp = css`
    && {
        margin-bottom: 8px;
        align-items: flex-start;
        -webkit-box-align: start;
    }
`;
const sharedSmallTextStyles: TypographyProps = {
    size: 14,
    lineHeight: "17px",
    weight: fontConfig.weight.bold,
    color: "text.main",
    css: css`
        vertical-align: unset;
        margin-bottom: 0;
        ${wrapInContainerStyles}
        ${ellipsis(2)}
    `,
};
const sharedMediumTextStyles: TypographyProps = {
    size: 28,
    lineHeight: "34px",
    weight: fontConfig.weight.black,
    color: "text.main",
    css: css`
        letter-spacing: 0;
        vertical-align: unset;
        margin-bottom: 0;
        ${wrapInContainerStyles}
    `,
};

const productDescriptionVariantStyles: ProductDescriptionVariantStyles = {
    small: {
        productDetailDescription: {
            ...mergeWithCss(sharedSmallTextStyles, { css: sharedStyles }),
        },
        productDetailLink: {
            ...mergeWithCss(
                {
                    color: "text.main",
                    typographyProps: {
                        ...sharedSmallTextStyles,
                    },
                    css: css`
                        width: auto;
                        &:hover ${StyledTypography} {
                            color: ${color("common.ui10")};
                        }
                    `,
                },
                { css: sharedStyles },
            ),
        },
    },
    medium: {
        productDetailDescription: {
            ...mergeWithCss(sharedMediumTextStyles, { css: sharedStyles }),
        },
        productDetailLink: {
            ...mergeWithCss(
                {
                    color: "text.main",
                    typographyProps: {
                        ...sharedMediumTextStyles,
                    },
                    css: css`
                        width: auto;
                        &:hover ${StyledTypography} {
                            color: ${color("common.10")};
                        }
                    `,
                },
                { css: sharedStyles },
            ),
        },
    },
};

export default productDescriptionVariantStyles;
